module.exports = __webpack_public_path__ + "media/images/al-izza-f7f79d766334318db5e2b3509a26a6ce.png";